import {useState} from 'react'
import { steps } from './stepsCannedContent'

const prep = 'Prepare your Skin'
const productGroups = [
  {name: prep, layers: ['primer']},
  {name: 'Foundation', layers: ['foundation']},
  {name: 'Concealer', layers: ['concealer']},
  {name: 'Blush', layers: ['blusher']},
  {name: 'Contour', layers: ['contour', 'highlighter']},
  {name: 'Highlight', layers: ['highlighter']},
  {name: 'Bronzer', layers: ['bronzer']},
  {name: 'Eyeshadow', layers: ['eyeshadow']},
  {name: 'Mascara', layers: ['mascara', 'eyelashes']},
  {name: 'Eyebrow', layers: ['eyebrow']},
  {name: 'Lipstick', layers: ['lipliner', 'lipstick', 'lipgloss']},
]

const layerProducts = products => {
  const builder = []
  return productGroups.map(({name, layers}) => {
    const thisLayerProducts = products.filter(
      ({regions: [{data, rendering}]}) =>
      layers.includes(data.type ?? rendering.type)
    )
    builder.push(...thisLayerProducts)
    return {
      name,
      layers,
      products: thisLayerProducts,
      layeredProducts: [...builder],
    }
  }).filter(({name, products}) => name === prep || products.length > 0)
}

export const TabSteps = ({rawProducts, sendProducts}) => {
  const steps = layerProducts(rawProducts)

  const [currentStep, setCurrentStep] = useState()
  const toggleStep = (name, layeredProducts) => {
    sendProducts(name === currentStep ? [] : layeredProducts)
    setCurrentStep(name === currentStep ? undefined : name)
  }

  return (<>
    <section>
      <div className="heading size-l">Applying this look</div>
      <div className="content size-m">
        To get the best result, we've broken application down into easy steps.
      </div>
    </section>
    {steps.map(({name, layeredProducts}) => <>
      {name === prep ? null : <Separator key={`${name}-separator`}/>}
      <Step
        name={name}
        expanded={name === currentStep}
        onClick={() => toggleStep(name, layeredProducts)}
        key={name}
      />
    </>)}
  </>)
}

const Separator = () => <div className="step-separator" />

const Step = ({name, expanded, onClick}) => {
  return (
    <section className="step column">
      <div className="heading size-l" onClick={onClick}>
        {name}
      </div>
      <div className={`content size-m ${expanded ? '' : 'collapsed'}`}>
        <ul className='list-none'>
          {steps[name].map((it, idx) => (
            <li key={idx}>
              {it.title && <h1 className='title'>{it.title}</h1>}
              {Array.isArray(it.content) && it.content.map((subsection, subIdx) => (
                <div key={subIdx}>
                  {subsection.title && <h2 className='subtitle'>{subsection.title}</h2>}
                  <p>{subsection.content}</p>
                </div>
              ))}
              {!Array.isArray(it.content) && <p>{it.content}</p>}
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
